import styled from 'styled-components';

import { Text, TextArea, Button as YogaButton } from '@gympass/yoga';

import { Button } from '..';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: ${({ theme }) => theme.yoga.spacing.xlarge}px
    ${({ theme }) => theme.yoga.spacing.zero};
  width: 100%;
  max-width: 520px;
  height: 100%;
`;

export const DrawerTitle = styled(Text)`
  font-size: ${({ theme }) => theme.yoga.fontSizes.xsmall}px;
  font-weight: ${({ theme }) => theme.yoga.fontWeights.medium};
  line-height: ${({ theme }) => theme.yoga.lineHeights.xsmall}px;
  color: ${({ theme }) => theme.yoga.colors.stamina};
  text-transform: uppercase;
`;

export const TitleContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  flex-grow: 1;
`;

export const PatientRecordEntryHistory = styled.section<{ formHeight: number }>`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  margin-top: calc(
    ${({ formHeight }) => formHeight}px -
      ${({ theme }) => theme.yoga.spacing.small}px
  );
`;

export const HistoryTitle = styled(Text.Medium)`
  align-self: flex-start;
  margin-bottom: ${({ theme }) => theme.yoga.spacing.large}px;
`;

export const RecordEntry = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 100%;

  & + & {
    border-top: 1px solid ${({ theme }) => theme.yoga.colors.light};
    margin-top: ${({ theme }) => theme.yoga.spacing.small}px;
    padding-top: ${({ theme }) => theme.yoga.spacing.small}px;
  }

  &:last-child {
    margin-bottom: ${({ theme }) => theme.yoga.spacing.medium}px;
  }
`;

export const RecordEntryInfo = styled(Text.Small)`
  margin-bottom: ${({ theme }) => theme.yoga.spacing.xxsmall}px;
  color: ${({ theme }) => theme.yoga.colors.text.disabled};
`;

export const RecordEntryContent = styled(Text)`
  color: ${({ theme }) => theme.yoga.colors.text.primary};
`;

export const NewPatientRecordEntryContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 100%;
  margin-bottom: ${({ theme }) => theme.yoga.spacing.small}px;
  border-bottom: 1px solid ${({ theme }) => theme.yoga.colors.light};
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  padding: ${({ theme }) => theme.yoga.spacing.xlarge}px
    ${({ theme }) => theme.yoga.spacing.xxlarge}px
    ${({ theme }) => theme.yoga.spacing.small}px;
  background-color: ${({ theme }) => theme.yoga.colors.white};
`;

export const NewPatientRecordEntrySubtitle = styled(Text)`
  margin-top: ${({ theme }) => theme.yoga.spacing.xxsmall}px;
  color: ${({ theme }) => theme.yoga.colors.text.disabled};
`;

export const NewPatientRecordEntryTextArea = styled(TextArea)`
  margin-top: ${({ theme }) => theme.yoga.spacing.large}px;
  line-height: ${({ theme }) => theme.yoga.lineHeights.small}px;

  fieldset {
    height: 170px;
  }
`;

export const NewPatientRecordEntrySaveButton = styled(props => (
  <Button {...props} />
))`
  margin-top: ${({ theme }) => theme.yoga.spacing.small}px;
  border-radius: ${({ theme }) => theme.yoga.radii.regular}px;
  padding: ${({ theme }) => theme.yoga.spacing.xxsmall}px
    ${({ theme }) => theme.yoga.spacing.xxlarge}px;
  font-size: ${({ theme }) => theme.yoga.fontSizes.small}px;
  line-height: ${({ theme }) => theme.yoga.lineHeights.xsmall}px;
  font-weight: ${({ theme }) => theme.yoga.fontWeights.regular};
  width: 119px;
  height: ${({ theme }) => theme.yoga.spacing.xlarge}px;
`;

export const CloseIcon = styled(YogaButton.Icon)`
  width: ${({ theme }) => theme.yoga.spacing.small}px;
  height: ${({ theme }) => theme.yoga.spacing.small}px;
`;

export const HeaderNewEntry = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  margin-bottom: ${({ theme }) => theme.yoga.spacing.xlarge}px;
`;
